import PowCustomerService from '../services/pow-customer.service'
import { CUST_QUERY_RESULTS } from './actions.types'
import {
  CUST_SET_SEARCH_RESULTS, CUST_SET_SEARCH_QUERY, CUST_SET_USE_CACHE, CUST_RESET_SEARCH,
} from './mutations.types'

const initialState = {
  wirelessServices: [],
  towers: [],
  searchQuery: '',
  useCache: false,
  searchResults: [],
}
export const state = { ...initialState }

export const actions = {
  async [CUST_QUERY_RESULTS] ({ dispatch, commit, rootState, state }, payload) {
    try {
      // console.log('logging in with: ', payload)
      const { data } = await PowCustomerService.searchCustomers(payload)
      commit(CUST_SET_SEARCH_RESULTS, data)
      return data
    } catch (e) {
      await dispatch('processAxiosError', e)
      console.log(e)
      return []
    }
  },
}

export const mutations = {
  [CUST_SET_SEARCH_QUERY] (state, payload) {
    state.searchQuery = payload
  },
  [CUST_SET_SEARCH_RESULTS] (state, payload) {
    state.searchResults = payload
  },
  [CUST_SET_USE_CACHE] (state, payload) {
    state.useCache = payload
  },
  [CUST_RESET_SEARCH] (state, payload) {
    state.searchQuery = ''
    state.searchResults = []
  },
}
export const getters = {
  // bearerToken: state => state.authToken,
  custSearchQuery: state => state.searchQuery,
  custUseCache: state => state.useCache,
  custSearchResults: state => state.searchResults,
}
export default {
  state,
  actions,
  mutations,
  getters,
}
